import Slides from './Slides.js';

import img1 from './images/portfolio/weddings-and-engagements/3/0659.jpg';
import img2 from './images/portfolio/weddings-and-engagements/3/069.jpg';
import img3 from './images/portfolio/weddings-and-engagements/3/0718_DSC7951.jpg';
import img4 from './images/portfolio/weddings-and-engagements/3/0721_DSC8313.jpg';
import img5 from './images/portfolio/weddings-and-engagements/3/080.jpg';
import img6 from './images/portfolio/weddings-and-engagements/3/081.jpg';
import img7 from './images/portfolio/weddings-and-engagements/3/082209_0457.jpg';
import img8 from './images/portfolio/weddings-and-engagements/3/082209_0473.jpg';
import img9 from './images/portfolio/weddings-and-engagements/3/082209_0914.jpg';
import img10 from './images/portfolio/weddings-and-engagements/3/089.jpg';
import img11 from './images/portfolio/weddings-and-engagements/3/091.jpg';
import img12 from './images/portfolio/weddings-and-engagements/3/0998_DSC7566.jpg';
import img13 from './images/portfolio/weddings-and-engagements/3/115.jpg';
import img14 from './images/portfolio/weddings-and-engagements/3/1176_IMG6129.jpg';
import img15 from './images/portfolio/weddings-and-engagements/3/127.jpg';
import img16 from './images/portfolio/weddings-and-engagements/3/165.jpg';
import img17 from './images/portfolio/weddings-and-engagements/3/170.jpg';
import img18 from './images/portfolio/weddings-and-engagements/3/181.jpg';
import img19 from './images/portfolio/weddings-and-engagements/3/191.jpg';
import img20 from './images/portfolio/weddings-and-engagements/3/217.jpg';
import img21 from './images/portfolio/weddings-and-engagements/3/222.jpg';
import img22 from './images/portfolio/weddings-and-engagements/3/231.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
];

function Architectural() {
    return <Slides images={images}/>;
}

export default Architectural;
